<template>
  <figure class="container my-10 group">
    <nuxt-link v-if="topic[0]" class="relative block overflow-hidden" :to="$localeRootPath(topic[0].uri)">
      <FixedAspect
        :ratio="1.3"
        class="md:hidden max-w-none object-cover w-full transition-transform duration-700 transform"
      >
        <CldnImg
          v-if="image[0]"
          :src="image[0].url"
          crop="fill"
          :ratio="1.3"
          sizes="100vw"
          :alt="alt ? alt : image[0].title"
        />
      </FixedAspect>
      <FixedAspect
        :ratio="0.6"
        class="max-w-none md:block hidden object-cover w-full transition-transform duration-700 transform"
      >
        <CldnImg
          v-if="image[0]"
          :src="image[0].url"
          crop="fill"
          :ratio="0.6"
          sizes="100vw"
          :alt="alt ? alt : image[0].title"
        />
      </FixedAspect>
      <figcaption class="md:p-10 absolute bottom-0 p-4">
        <BarText v-if="heading" tag="h2" :text="heading" class="fluid-4xl leading-none" />
      </figcaption>
      <div
        class="overlay bg-blackly absolute inset-0 transition-opacity duration-700 opacity-0 pointer-events-none group-hover:opacity-25"
      ></div>
    </nuxt-link>
  </figure>
</template>

<script>
import CldnImg from '@/components/CldnImg';
import FixedAspect from '@/components/common/FixedAspect';
import BarText from '@/components/BarText';

export default {
  components: { CldnImg, FixedAspect, BarText },
  props: {
    image: {
      type: Array,
      default: () => [],
    },
    alt: {
      type: String,
      default: null,
    },
    heading: {
      type: String,
      default: null,
    },
    topic: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
